const apiUrl = process.env.VUE_APP_API_BASE_URL;

export default {
    base: `${apiUrl}/api/v1`,
    sanctumCookie: `${apiUrl}/sanctum/csrf-cookie`,
    login_employee: `${apiUrl}/api/v1/employee/login`,
    login_customer: `${apiUrl}/api/v1/customer/login`,
    forgot_password: `${apiUrl}/api/v1/password/email`,
    reset_password: `${apiUrl}/api/v1/password/reset`,
    logout: `${apiUrl}/api/v1/logout`,
    kit_sizer: {
        getModules: `${apiUrl}/api/v1/products/category/module`,
        getInverters: `${apiUrl}/api/v1/products/category/inverter`,
        size: `${apiUrl}/api/v1/kit_sizer/generate_kit`,
        kit_editor: `${apiUrl}/api/v1/kit_editor`,
        save: `${apiUrl}/api/v1/kits`,
        products: `${apiUrl}/api/v1/kit_products`,
    },
    string_sizer: {
        get: `${apiUrl}/api/v1/string_sizer/calculate_arrangements`,
        generatePossibilities: `${apiUrl}/api/v1/photovoltaic_arrangement`,
        generatePossibilitiesQueue: `${apiUrl}/api/v1/photovoltaic_arrangement/queue`,
        getUniqueCombinations: `${apiUrl}/api/v1/photovoltaic_arrangement/unique_combinations`,
    },
    cities: `${apiUrl}/api/v1/cities`,
    budgets: `${apiUrl}/api/v1/budgets`,
    brands: `${apiUrl}/api/v1/brands`,
    brands_inverters: `${apiUrl}/api/v1/brands_inverters`,
    permissions: `${apiUrl}/api/v1/permissions`,
    roles: `${apiUrl}/api/v1/roles`,
    products: `${apiUrl}/api/v1/products`,
    products_categories: `${apiUrl}/api/v1/products_categories`,
    states: `${apiUrl}/api/v1/states`,
    structure_types: `${apiUrl}/api/v1/structure_types`,
    address: `${apiUrl}/api/v1/addresses`,
    orders: `${apiUrl}/api/v1/orders`,
    shipping: `${apiUrl}/api/v1/shipping_config`,
    shipping_rules: `${apiUrl}/api/v1/shipping_rule_types`,
    orders_status: `${apiUrl}/api/v1/order_status`,
    customers: `${apiUrl}/api/v1/customers`,
    users: `${apiUrl}/api/v1/users`,
    register_customer: `${apiUrl}/api/v1/customer/register`,
    register_customer_with_log: `${apiUrl}/api/v1/customers/registerWithLog`,
    dashboard: `${apiUrl}/api/v1/dashboard`,
    banners: `${apiUrl}/api/v1/banners`,
    provider: `${apiUrl}/api/v1/suppliers`,
    brasilapi: {
        cep: `https://brasilapi.com.br/api/cep/v2/`,
        cnpj: `https://brasilapi.com.br/api/cnpj/v1/`,
    },
    end_user: `${apiUrl}/api/v1/end_users`,
    notifications: `${apiUrl}/api/v1/notifications`,
    messageBoard: `${apiUrl}/api/v1/message_board`,
    metrics: `${apiUrl}/api/v1/metrics`,
};
